import { toDate as e } from "./toDate.js";
function a(n) {
  const t = e(n), o = t.getMonth(), r = o - o % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
export {
  a as default,
  a as startOfQuarter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfQuarter.js
// module id = 454
// module chunks = 67